import gql from "graphql-tag";

export const MY_HR_GET_CHANGE_REQUESTS_EXAMINERS_NAME = gql`
  query getChangeRequestsExaminersName($locale: String, $contract: String!) {
    getChangeRequestsExaminersName(locale: $locale, contract: $contract)
  }
`;
